// Fixed recipe taxonomy — mirrors /app/backend/taxonomy.py exactly.
// Change one, change the other.

export const CATEGORY_LABELS = {
  savory:   "مالح",
  sweet:    "حلو",
  beverage: "مشروبات",
  sauces:   "صلصات وتتبيلات",
};

export const CATEGORIES = ["savory", "sweet", "beverage", "sauces"];

export const TAXONOMY = {
  savory: [
    "أطباق رئيسية",
    "أرز وحبوب",
    "مكرونة ونودلز",
    "ساندويتشات ولفائف",
    "بيتزا ومعجنات",
    "سلطات",
    "شوربات",
    "مقبلات وأطباق جانبية",
    "سناكات مالحة",
  ],
  sweet: [
    "كيك وتشيزكيك",
    "كوكيز وبسكويت",
    "فطائر ومعجنات حلوة",
    "بان كيك وفطور حلو",
    "حلويات مجمدة",
    "حلويات كريمية",
    "حلويات صغيرة وبارات",
  ],
  beverage: [
    "قهوة",
    "شاي وأعشاب",
    "عصائر",
    "سموذي",
    "بروتين ومخفوقات",
    "حليب وكاكاو",
    "مشروبات منعشة",
  ],
  sauces: [
    "صلصات الطبخ والتقديم",
    "تغميسات ودهانات",
    "تتبيلات سلطات",
    "تتبيلات ونقع",
    "صلصات حلوة",
  ],
};

export function getSubcategories(category) {
  return TAXONOMY[category] || [];
}
